import { components } from "@/api-schema";

type VehicleBlockReason = components["schemas"]["VehicleBlock"]["reason"];

export const VEHICLE_BLOCK_REASONS: Record<VehicleBlockReason, string> = {
  Maintenance: "masterdata:Maintenance",
};
